import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Moment} from 'moment';
import {FormBuilder} from '@angular/forms';
import {SharedService} from '../../../shared/shared.service';
import {catchError, debounceTime, distinctUntilChanged, map, tap} from 'rxjs/operators';
import {of, Subscription} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import * as moment from 'moment';
import {FormService} from '../../../shared/form.service';

@Component({
  selector: 'app-details3',
  templateUrl: './details3.component.html',
  styleUrls: ['./details3.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Details3Component implements OnInit, OnDestroy {
  changeSubs = new Subscription();
  ownerDetailsSubscription;
  parentForm;
  personOwnerData;
  companyOwnerData;
  ownersGroup;
  startDate: Moment = null;
  ownerGroupName = 'personOwnerData';
  insurancesDates;
  minDate = moment().add(1, 'days');
  maxDate = moment();
  public parseFormat = ['DD/MM/YYYY'];

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  constructor(
    public sharedService: SharedService,
    public http: HttpClient,
    private formBuilder: FormBuilder,
    private chRef: ChangeDetectorRef,
    private formService: FormService) {
  }

  clearContactDetails(details) {
    ['eik', 'companyName', 'phoneNumber', 'egn', 'firstName', 'middleName', 'lastName', 'firstNameInLatin', 'middleNameInLatin', 'lastNameInLatin', 'addressInLatin', 'email'].map(item => {
      if (details[item]) {
        delete details[item];
      }
    });
    return details;
  }

  getBDay(egnNum) {
    let monthBorn = this.getNums(egnNum, 2, 2);
    const dayBorn = this.getNums(egnNum, 4, 2);
    var year_flag = 1900;

    if (monthBorn > 40) {
      year_flag += 100;
    } else if (monthBorn > 20) {
      year_flag -= 100;
    }

    monthBorn = (monthBorn % 20) - 1;
    // 'MM/DD/YYYY
    // return `${monthBorn}/${year_flag + this.getNums(egnNum, 0, 2)}/${dayBorn}`;
    return moment(new Date(year_flag + this.getNums(egnNum, 0, 2), monthBorn, dayBorn));
  }

  getNums(str, start, simbolNum) {
    return (str.substr(start, simbolNum) * 1);
  }

  updateGroup(egn = '') {
  }

  ngOnInit(): void {
    this.sharedService.reloadProposals = true;
    this.insurancesDates = this.formBuilder.group({
      mtplEndDate: null,
      cascoEndDate: null
    });
    this.ownerGroupName = 'personOwnerData';
    this.parentForm = this.formService.currentForm;
    this.changeSubs.add(this.sharedService.newRegSubj.pipe(catchError(err => of(err)), debounceTime(300), distinctUntilChanged())
      .subscribe((data: any) => {
        if (data.length === 10) {
          this.ownerGroupName = 'personOwnerData';
          this.parentForm.controls.samePerson.enable();
          if (this.parentForm.getRawValue().samePerson === 'N') {
            this.parentForm.controls.samePerson.patchValue(null);
          }
          this.parentForm.controls.isCompany.patchValue(false);
          this.sharedService.loadingSpinner = ' ';
          this.chRef.detectChanges();
          this.http.get(`/api/v1/person/${data}`).pipe(
            catchError(err => {
              this.sharedService.loadingSpinner = false;
              return of(null);
            })
          ).subscribe((res: any) => {
            this.sharedService.loadingSpinner = false;
            if (res) {
              this.clearContactDetails(res);
              res.phoneNumber = res.phoneNumber?.replace('00', '+');
              this.parentForm.controls.personOwnerData.patchValue(res);
            } else {
              this.parentForm.get('personOwnerData.dDateOfBirth').patchValue(this.getBDay(data));
            }
            this.chRef.detectChanges();
          });
        } else if (data.length === 9 || data.length > 10) {
          this.sharedService.loadingSpinner = ' ';
          this.parentForm.controls.isCompany.patchValue(true);
          this.parentForm.controls.samePerson.patchValue('N');
          this.parentForm.controls.samePerson.disable();
          this.ownerGroupName = 'companyOwnerData';
          this.chRef.detectChanges();
          this.http.get(`/api/v1/company/${data}`).pipe(
            catchError(err => {
              this.sharedService.loadingSpinner = false;
              return of(false);
            })
          ).subscribe((res: any) => {
            this.sharedService.loadingSpinner = false;
            if (res) {
              const {eik} = res;
              this.clearContactDetails(res);
              res.phoneNumber = res.phoneNumber?.replace('00', '+');
              this.parentForm.controls.companyOwnerData.patchValue(res);
              this.parentForm.controls.companyOwnerData.controls.eik.patchValue(eik);
            } else {
              this.parentForm.get('companyOwnerData.eik').patchValue(data);
              // this.parentForm.get('personOwnerData.dDateOfBirth').patchValue(this.getBDay(data));
            }
            this.chRef.detectChanges();
          });
        }
      }));

    this.changeSubs.add(this.sharedService.subj.pipe(catchError(err => of(err)), debounceTime(300), distinctUntilChanged())
      .subscribe((data: any) => {
        if (this.ownerDetailsSubscription) {
          this.ownerDetailsSubscription.unsubscribe();
          this.sharedService.loadingSpinner = false;
        }
        if (!data) {
          this.parentForm.controls.personOwnerData.patchValue({postCode: '', dDateOfBirth: ''});
          this.parentForm.controls.companyOwnerData.patchValue({postCode: ''});
          return;
        }
        const params = new HttpParams({
          fromObject: {
            tn: this.formService.currentForm.value.vehicleDTO.regTalonNumber,
            dkn: this.formService.currentForm.value.vehicleDTO.vehRegPlate,
            nationalId: data
          }
        });
        this.sharedService.loadingSpinner = ' ';
        this.ownerDetailsSubscription = this.http.get('/api/v1/vehicle/owner/', {params}).pipe(
          catchError(err => {
            this.sharedService.loadingSpinner = false;
            return of(false);
          })
        ).subscribe((res: any) => {
          this.sharedService.loadingSpinner = false;
          if (res.phoneNumber) {
            res.phoneNumber = res.phoneNumber?.replace('00', '+');
          }
          if (res.hasOwnProperty('personOwnerData')) {
            this.ownerGroupName = 'personOwnerData';
            let {personOwnerData, insSum} = res;
            this.clearContactDetails(personOwnerData);
            this.personOwnerData = personOwnerData;
            personOwnerData.partnerType = 'P';
            personOwnerData.dDateOfBirth = moment(personOwnerData.dDateOfBirth);
            this.parentForm.patchValue({
              personOwnerData, companyOwnerData: {
                'partnerType': 'I'
              }, insSum
            });
            this.parentForm.controls.samePerson.patchValue(null);
            this.parentForm.controls.samePerson.enable();
            this.parentForm.controls.isCompany.patchValue(false);
          } else if (res.hasOwnProperty('companyOwnerData')) {
            this.ownerGroupName = 'companyOwnerData';
            this.parentForm.controls.isCompany.patchValue(true);
            this.parentForm.controls.samePerson.patchValue('N');
            this.parentForm.controls.samePerson.disable();
            const {companyOwnerData, insSum = 1234} = res;
            this.clearContactDetails(companyOwnerData);
            this.companyOwnerData = companyOwnerData;
            this.parentForm.patchValue({
              companyOwnerData, personOwnerData: {
                'partnerType': 'P'
              }, insSum
            });
          } else {
            this.parentForm.get('personOwnerData.egn').setErrors({'invalid': true});
            this.parentForm.get('personOwnerData.egn').markAsDirty();
            this.parentForm.get('personOwnerData.egn').markAsTouched();
            // this.parentForm.get('personOwnerData.egn').updateValueAndValidity();
          }
        });
      }));
  }

  trackByIndex(index: number) {
    return index;
  };


  restrict_char(event) {
    var k = event.charCode;
    return (k > 46 && k < 58);
  }

  myFilter(search, itemValue) {
    if (!search) {
      return itemValue.match(new RegExp('^1', 'gi')) !== null;
    }
    return itemValue.match(new RegExp('^' + search, 'gi')) !== null;
  }

  validateInput(field){
    this.parentForm.controls.personOwnerData.patchValue({egn: field.replace(/\D/g,'')});
  }

  ngOnDestroy() {
    this.changeSubs.unsubscribe();
  }

}
